module.exports = __webpack_public_path__ + "img/part3-label1.834a942e.png";